var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd-input-wrapper',{attrs:{"rules":_vm.rules,"title":_vm.title}},[_c('div',{ref:"self",staticClass:"btn-group radio-group flex-row multi-switch"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }